import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { logEvent } from "firebase/analytics";
import { getApiKey } from "./api";

// Initialize Firebase asynchronously after fetching the API key
export let app = null;
let firebaseInitPromise = null;

const initializeFirebase = async () => {
  if (app) return app; // Return existing app if already initialized

  if (firebaseInitPromise) return firebaseInitPromise; // Return existing promise if initialization is in progress

  firebaseInitPromise = (async () => {
    const apiKeyResponse = await getApiKey("firebase");
    const apiKey = apiKeyResponse.data;
    if (apiKeyResponse.response !== 200 || !apiKey) {
      throw new Error("Failed to fetch Firebase API key");
    }

    const firebaseConfig = {
      apiKey: apiKey,
      authDomain: "vb-events.firebaseapp.com",
      databaseURL: "https://vb-events.firebaseio.com",
      projectId: "vb-events",
      storageBucket: "vb-events.firebasestorage.app",
      messagingSenderId: "755782043124",
      appId: "1:755782043124:web:65965e93891f1574b465a1",
      measurementId: "G-DFXB51Y6SW",
    };

    app = initializeApp(firebaseConfig);
    return app;
  })();

  return firebaseInitPromise;
};

const logAnalyticsEvent = async (name, params) => {
  if (process.env.NODE_ENV === "production") {
    try {
      const firebaseApp = await initializeFirebase();
      const analytics = getAnalytics(firebaseApp);
      if (analytics) {
        logEvent(analytics, name, params);
      }
    } catch (error) {
      console.error("Error logging analytics event:", error);
    }
  }
};

// Start initialization immediately
const appPromise = initializeFirebase();

export { appPromise, logAnalyticsEvent };
